<template>
  <div id="vanber">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>校企合作申请</el-breadcrumb-item>
        <el-breadcrumb-item>新增合作申请</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <hr>
    <el-row>
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="80px">
          <el-form-item label="意向合作学校" prop="school_id">
            <el-select v-model="form.school_id" filterable placeholder="请选择">
              <el-option v-for="item in schoolList" :key="item.id" :label="item.fdName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        schoolList: "",
        form: {
          school_id: '',
        },
        rules: {
          school_id: [
            { required: true, message: "请输入学校", trigger: "change" }
          ],
        }
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      // 获取学校列表
      async getList() {
        let school = await this.$api.school.getSchool(1, 100);
        if (school.code === 0) {
          this.schoolList = school.data.items;
        }
      },
      // 提交
      onSubmit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            this.applyAdd();
          } else {
            return false;
          }
        });
      },
      // 确认提交
      async applyAdd() {
        try {
          let params = {
            school_id: this.form.school_id,
          };
          let res = await this.$api.school.applyAdd(params);
          if (res.code === 0) {
            this.$router.push({
              path: '/pay',
              query: {
                pay_subject: 'school',
                relation_id: res.data.id,
                school_id: this.form.school_id
              }
            })
          }
        } catch (e) {
          console.log("​catch -> e", e);
        }
      },
      async getSchoolPayInfo(relation_id) {
        let res = await this.$api.pay.getSchoolPayInfo(relation_id)
        return res
      },
    }
  };
</script>

<style lang="scss">
  #vanber {
    padding: 20px;
  }
</style>